// src/pages/VerificationPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import "./VerificationPage.css";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF, FaMicrosoft, FaApple } from "react-icons/fa";

export default function VerificationPage() {
  const [user] = useState(null);
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const redirect = params.get("redirect") || "/services";
  const auth = getAuth();
  const googleProvider = new GoogleAuthProvider();
  const facebookProvider = new FacebookAuthProvider();
  const microsoftProvider = new OAuthProvider("microsoft.com");
  const appleProvider = new OAuthProvider("apple.com");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.setItem("isVerified", "true");
        navigate(redirect);
      }
    });
    return unsubscribe;
  }, [auth, navigate, redirect]);

  const handleGoogleSignIn = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      console.error("Google sign-in error:", err);
    }
  };
  const handleFacebookSignIn = async () => {
    try {
      await signInWithPopup(auth, facebookProvider);
    } catch (err) {
      console.error("Facebook sign-in error:", err);
    }
  };
  const handleMicrosoftSignIn = async () => {
    try {
      await signInWithPopup(auth, microsoftProvider);
    } catch (err) {
      console.error("Microsoft sign-in error:", err);
    }
  };
  const handleAppleSignIn = async () => {
    try {
      await signInWithPopup(auth, appleProvider);
    } catch (err) {
      console.error("Apple sign-in error:", err);
    }
  };

  return (
    <div className="verification-page">
      <div className="verification-container">
        <h2>Please verify</h2>
        {user ? (
          <p>Welcome, {user.displayName}!</p>
        ) : (
          <div className="social-buttons">
            <button className="social-button social-email">
              <span className="icon">✉️</span>
              Continue with Email
            </button>
            <button
              onClick={handleGoogleSignIn}
              className="social-button social-google"
            >
              <FcGoogle className="icon" size={22} />
              Continue with Google
            </button>
            <button
              onClick={handleFacebookSignIn}
              className="social-button social-facebook"
            >
              <FaFacebookF className="icon" size={20} />
              Continue with Facebook
            </button>
            <button
              onClick={handleMicrosoftSignIn}
              className="social-button social-microsoft"
            >
              <FaMicrosoft className="icon" size={20} />
              Continue with Microsoft
            </button>
            <button
              onClick={handleAppleSignIn}
              className="social-button social-apple"
            >
              <FaApple className="icon" size={22} />
              Continue with Apple
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
